"use client";

import { ConvexAuthNextjsProvider } from "@convex-dev/auth/nextjs";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import type { ReactNode } from "react";
import { resolveConvexClientUrl } from "@/core/auth/convex-url";

let convexClient: ConvexReactClient | undefined;

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  const convexUrl = resolveConvexClientUrl(process.env.NEXT_PUBLIC_CONVEX_URL);

  convexClient ??= new ConvexReactClient(convexUrl.url);

  if (!convexUrl.configured) {
    return <ConvexProvider client={convexClient}>{children}</ConvexProvider>;
  }

  return <ConvexAuthNextjsProvider client={convexClient}>{children}</ConvexAuthNextjsProvider>;
}
